module.exports = __webpack_public_path__ + "img/LKW_Lbw_7t.fb412b5a.svg";